import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  Input,
  ViewEncapsulation,
  inject,
} from '@angular/core';
import { Params, Router } from '@angular/router';

import { SharedModule } from '../../../shared.module';

@Component({
  selector: 'app-widget-number-display',
  templateUrl: './widget-number-display.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [SharedModule],
})
export class WidgetNumberDisplayComponent {
  @Input() navigateOnClick: boolean = false;

  @Input() hyperlink: string | null = null;

  @Input() queryParams: Params | null = null;

  @Input() loading: boolean = true;

  @Input() ctaText: string = '';

  @Input() status: string = '';

  @Input() number: number = 0;

  @Input() title: string = '';

  @Input() label: string = '';

  private readonly router$ = inject(Router);

  @HostListener('click') onClick(): void {
    if (!this.hyperlink) return;
    if (!this.navigateOnClick || this.loading) return;
    this.router$.navigate([this.hyperlink], {
      queryParams: this.queryParams ?? undefined,
    });
  }
}
